import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import classNames from 'classnames';

import {
    Sizes,
    Colours,
    AnimatedFadeContainer,
    IconMinus,
    IconPlus,
    PageBehaviourButton,
} from '@ratehub/base-ui';
import { CreditCardShape } from '@ratehub/cc-common';

import CardDetailsTable from './CardDetailsTable';


function ExpandableCardDetailsTable({ cardInfo }) {
    const [ showingMoreDetails, setShowingMoreDetails ] = useState(false);

    return (
        <div>
            <AnimatedFadeContainer
                className="expandable-container"
                isVisible={showingMoreDetails}
                alwaysRenderChildMarkup={true}
            >
                <h3 className={classNames('rh-title-m', 'rh-mt-2_5', 'rh-mb-1')}>
                    <FormattedMessage
                        id="cc.details.card-details-subtitle"
                        defaultMessage="{name} details"
                        values={cardInfo}
                    />
                </h3>

                <MyOutdentedHorizontalRule />

                <CardDetailsTable cardInfo={cardInfo} />
            </AnimatedFadeContainer>

            <MyPageBehaviourButton
                size="medium"
                iconLocation="left"
                message={(
                    <FormattedMessage
                        id="cc.details.more-close-details"
                        defaultMessage={`{showingMoreDetails, select,
    true {close card details}
    other {more card details}
}`}
                        values={{ showingMoreDetails: showingMoreDetails }}
                    />
                )}
                iconComponent={showingMoreDetails ? IconMinus : IconPlus}
                onClick={() => setShowingMoreDetails(!showingMoreDetails)}
            />
        </div>
    );
}

ExpandableCardDetailsTable.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};

const MyOutdentedHorizontalRule = styled.hr`
    margin-left: -0.5em;
    width: calc(100% + 1em);
    border: none;
    border-top: 1px solid ${Colours.BLACKBERRY};
`;

const MyPageBehaviourButton = styled(PageBehaviourButton)`
    margin-top: ${Sizes.SPACING.THREE};
`;

export default ExpandableCardDetailsTable;
